import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteUser } from '../../../../actions';

class UserDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteUser, userId } = this.props;
    dispatchDeleteUser({ userId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        <i className="fa fa-trash" /> Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

UserDeleteButton.propTypes = {
  userId: PropTypes.number.isRequired,
  dispatchDeleteUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteUser: deleteUser,
};

export default connect(null, mapDispatchToProps)(UserDeleteButton);
